import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BiSearchAlt } from "react-icons/bi";
import { IoArrowBackSharp, IoArrowForwardSharp } from "react-icons/io5";
import { MdDoneAll } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertToDateString,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../../constants/const";
import { GetLanguageString } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";
import SearchAutoComplete from "../../../shared/SearchAutoComplete";
import { addMember } from "../../ApiMember";
import ResponsibilityErrorMessage from "../ResponsibilityErrorMessage";
import FormStepDeen from "./FormStepDeen";
import FormStepPersonal from "./FormStepPersonal";
import FormStepTanzeem from "./FormStepTanzeem";
import FormStepTasurat from "./FormStepTasurat";
import { FaUser } from "react-icons/fa";

const colors = {
  primary: "#1d9fad", // New primary color (teal-cyan)
  primaryLight: "#4dbbc8", // Lighter variant of new primary
  primaryDark: "#147d89", // Darker variant of new primary
  secondary: "#7DB9A2", // Dusty seafoam green
  accent: "#94C4CC", // Pale sky blue
  background: "#F8FBFB", // Very light blue-white
  text: "#2D3747", // Dark blue-gray
  textLight: "#6B7C8C", // Soft blue-gray
  border: "#D8E1E6", // Light blue-gray
  success: "#5AB885", // Muted green
  warning: "#E4B363", // Soft gold
  error: "#E67C73", // Dusty coral
  progressLine: "#D1DDE5", // Very light blue-gray
  stepInactive: "#E0E8EC", // Pale blue for inactive steps
};

const MuavaneenResponsibilityRequestForm = ({
  responsibilityValues,
  history,
}) => {
  const { t } = useTranslation();
  const selectedLanguage = GetSelectedLanguage();
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [displayMessageModal, setDisplayMessageModal] = useState(false);
  const notify = (string) => toast.success(string);
  const [errorMessages, setErrorMessages] = useState([]);
  const [regNoError, setRegNoError] = useState(false);
  const [members, setMembers] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchOption, setSearchOption] = useState("name"); // 'name' or 'regNo'
  const [name, setName] = useState("");
  const [regNoForSearch, setRegNoForSearch] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSearchByRegNo, setLoadingSearchByRegNo] = useState(false);
  const [hoverStep, setHoverStep] = useState(null);

  const [values, setValues] = useState({
    memberRegNo: "",
    memberName: "",
    memberFatherName: "",
    memberMaritalStatus: null,
    memberAge: "",
    proposedResponsibility: responsibilityValues.responsibility,
    previousAssignedResponsibilityMemberId: "",
    previousAssignedResponsibilityMember: "",
    previousAssignedResponsibilityMemberRegNo: "",
    additionalResponsibilities: [],
    previousResponsibilities: [],
    joiningDate: null,
    multazimDate: null,
    multazimCourseDate: null,
    isMultazimNisaabComplete: false,
    nuqabaCourseDate: null,
    umraNuqabaCourse: null,
    isZimedaranNisaabComplete: false,
    mudariseenCourse: null,
    mudariseenRefresherCourse: null,
    isMudariseenNisaabComplete: false,
    arabicGrammarTestStatus: {},
    tajweedTestStatus: {},
    isReadNizamUlAmalAndRahnumaAsool: false,
    deeniEducation: "",
    duniyawiEducation: "",
    knowledgeAboutAccounts: "",
    knowledgeAboutComputerUse: "",
    knowledgeAboutFinancialManual: "",
    ibadaat: "",
    ikhlaqiyat: "",
    muamlaat: "",
    literatureRevision: "",
    tilawatQuran: "",
    hifzQuran: "",
    tarjumaQuran: "",
    tafseeerQuran: "",
    infiradiDawat: "",
    attendanceInIjtimayiDawatiActivities: "",
    darsOTadrees: "",
    infaaqMaalWaqt: "",
    ghareluUsra: "",
    mutabadilTarbiat: "",
    ateendanceInIjtimaat: "",
    lfcReports: "",
    useOfElectronicMedia: "",
    avoidGhairMasnoonRasomaat: "",
    isSharayiPardaInHome: false,
    isSharayiPardaOutsideHome: false,
    avoidAttendingMehfilGhairMehram: "",
    physicalAppearance: "",
    wayOfLiving: "",
    sourceOfIncome: "",
    avoidHaram: "",
    maliLainDainMuamlat: "",
    otherInformation: "",
    dateOfRequest: new Date(),
    muqamiAmeerName: "",
    muqamiAmeerFeedback: "",
    ameerHalqaName: "",
    ameerHalqaFeedback: "",
    nazimAllaTabsaraOTasuraat: "",
    nazimAllaName: "",
  });

  useEffect(() => {
    if (name !== "" && !name.includes("/")) {
      setLoadingSearch(true);
      const timeoutId = setTimeout(() => {
        addMember()
          .getUnitParticipants(responsibilityValues.unit.value, name)
          .then((res) => {
            setMembers(res.data);
            setLoadingSearch(false);
          })
          .catch((err) => {
            console.log(err);
            setLoadingSearch(false);
          });
      }, 1500);
      return () => clearTimeout(timeoutId);
    }
    setMembers([]);
    setLoadingSearch(false);
  }, [responsibilityValues, name]);

  const handleOnSelect = (item) => {
    var str = item?.name;
    let remove = str.split(" - ").pop();
    let requiredName = str.replace(" - " + remove, "   ");
    setName("");
    setValues({
      ...values,
      previousAssignedResponsibilityMemberRegNo: item.memberRegNo,
      previousAssignedResponsibilityMember: requiredName,
      previousAssignedResponsibilityMemberId: item.id,
    });
    setShowSearch(false);
    setMembers([]);
  };

  const handleSearchByRegNo = useCallback(() => {
    if (!regNoForSearch.trim()) return;
    setLoadingSearchByRegNo(true);
    setRegNoError(false);
    setTimeout(() => {
      addMember()
        .getUnitParticipantsByRegNo(
          responsibilityValues.unit.value,
          regNoForSearch
        )
        .then((res) => {
          setValues({
            ...values,
            previousAssignedResponsibilityMemberRegNo: res.data.memberRegNo,
            previousAssignedResponsibilityMember: res.data.name,
            previousAssignedResponsibilityMemberId: res.data.id,
          });
          setShowSearch(false);
          setLoadingSearchByRegNo(false);
          setRegNoForSearch("");
        })
        .catch((err) => {
          console.log(err);
          setRegNoError(true);
          setLoadingSearchByRegNo(false);
        });
    }, 1500);
  }, [regNoForSearch, responsibilityValues, values]);

  useEffect(() => {
    setLoading(true);
    addMember()
      .MemberResponsibilityRequestMuavinFormData(
        responsibilityValues.memberId,
        responsibilityValues.memberRegNo,
        responsibilityValues.responsibility.value,
        responsibilityValues.unit.value,
        responsibilityValues.displayName
          ? responsibilityValues.displayName
          : null
      )
      .then((res) => {
        setValues({
          ...res.data,
          memberPhoto: "data:image/jpeg;base64," + res.data.memberPhoto,
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [responsibilityValues]);

  const nextStep = () => {
    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleCheckBoxes = (e) => {
    const { name, value } = e.target;
    let val = value === "true";
    setValues({
      ...values,
      [name]: val,
    });
  };
  const handleSubmit = () => {
    values.proposedResponsibility = responsibilityValues.responsibility;
    values.dateOfRequest = convertToDateString(new Date());
    values.memberPhoto = null;
    responsibilityValues.muavinRequest = values;
    setButtonDisable(true);
    setLoading(true);
    addMember()
      .addMemberResponsibility(responsibilityValues, false)
      .then((res) => {
        if (res.data.requestExists) {
          swal({
            title: t("member__request_exists_for_assign_responsibility"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });
          history.goBack();
          setLoading(false);
          setButtonDisable(false);
        } else if (res.data === "Invalid Data") {
          notify(res.data);
          setLoading(false);
          setButtonDisable(false);
        } else if (res.data.cannotAssignResponsibility) {
          swal({
            title: t(
              "member__member_responsibility_error_cannot_assign_resposnibility"
            ),
            icon: "error",
            buttons: "OK",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
          });
          setButtonDisable(false);
          setLoading(false);
        } else if (
          !res.data.thisMemberHaveResponsibility &&
          !res.data.otherMemberHaveResponsibility &&
          !res.data.isUsraMavin
        ) {
          swal({
            title: t("member__request_success_for_assign_responsibility"),
            icon: "success",
            buttons: "OK",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
          });
          history.goBack();
          setLoading(false);
          setButtonDisable(false);
        } else {
          setErrorMessages(res.data);
          setDisplayMessageModal(true);
          setLoading(false);
          setButtonDisable(false);
        }
      })
      .catch((err) => {
        swal({
          title: err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <FormStepPersonal
            setValues={setValues}
            values={values}
            handleCheckBoxes={handleCheckBoxes}
          />
        );
      case 2:
        return (
          <FormStepDeen
            setValues={setValues}
            values={values}
            handleCheckBoxes={handleCheckBoxes}
          />
        );
      case 3:
        return (
          <FormStepTanzeem
            values={values}
            setValues={setValues}
            handleCheckBoxes={handleCheckBoxes}
            handleInputChange={handleInputChange}
          />
        );
      case 4:
        return <FormStepTasurat values={values} setValues={setValues} />;
      default:
        return null;
    }
  };

  const getStepTitle = (step) => {
    switch (step) {
      case 1:
        return "ذاتی اعتبار سے";
      case 2:
        return "دینی اعتبار سے";
      case 3:
        return "تنظیمی اعتبار سے";
      case 4:
        return "امیر کے تاثرات";
      default:
        return "";
    }
  };

  return (
    <div
      className="ibox-content"
      style={{
        backgroundColor: colors.background,
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
      }}
    >
      {!loading ? (
        <>
          {displayMessageModal && (
            <ResponsibilityErrorMessage
              setDisplayMessageModal={setDisplayMessageModal}
              data={errorMessages}
              displayName={responsibilityValues.displayName}
            />
          )}
          <div
            style={{
              backgroundColor: colors.background,
              borderRadius: "12px",
              padding: "12px",
              marginBottom: "24px",
            }}
          >
            <Row>
              <Col md="2">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <Row>
                      <Col md="7">
                        {values.memberPhoto ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="bg-light rounded-circle overflow-hidden d-flex justify-content-center align-items-center me-3"
                              style={{ width: "100px", height: "100px" }}
                            >
                              <img
                                src={values.memberPhoto}
                                alt="Uploaded"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="bg-light rounded-circle p-3 me-3">
                            <FaUser
                              style={{ width: "100px", height: "100px" }}
                              className="text-primary"
                            />
                          </div>
                        )}
                      </Col>
                      <Col md="5">
                        <CardTitle
                          tag="h5"
                          style={{
                            color: colors.primary,
                            fontWeight: "600",
                            fontSize: "16px",
                            marginBottom: "12px",
                          }}
                        >
                          <GetLanguageString props={"common_name"} />
                        </CardTitle>
                        <CardText
                          className={isUrdu(values.memberName) ? "ur" : ""}
                          style={{
                            fontSize: "16px",
                            color: colors.text,
                            wordBreak: "break-word",
                          }}
                        >
                          {values.memberName || "—"}
                        </CardText>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="2">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props={"member_reg_number"} />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.memberRegNo) ? "ur" : ""}
                      style={{
                        fontSize: "16px",
                        color: colors.text,
                        wordBreak: "break-word",
                      }}
                    >
                      {getStringFromJSX(
                        applyClassToCharacters(values.memberRegNo, "ur")
                      ) || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="3">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString
                        props={"member__request_proposed_responsibility"}
                      />
                    </CardTitle>
                    <CardText
                      className="ur"
                      style={{
                        fontSize: "16px",
                        color: colors.text,
                        wordBreak: "break-word",
                      }}
                    >
                      {responsibilityValues.displayName
                        ? `(${responsibilityValues.displayName}) ${responsibilityValues.responsibility.label}`
                        : responsibilityValues.responsibility.label || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center">
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString
                          props={
                            "member__request_previous_member_responsibility"
                          }
                        />
                      </CardTitle>
                      {values.previousAssignedResponsibilityMember && (
                        <RxCross2
                          size={18}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setValues({
                              ...values,
                              previousAssignedResponsibilityMember: "",
                              previousAssignedResponsibilityMemberRegNo: "",
                            });
                          }}
                          className="text-muted"
                        />
                      )}
                    </div>
                    <CardText
                      className={
                        isUrdu(values.previousAssignedResponsibilityMember)
                          ? "ur"
                          : ""
                      }
                      style={{
                        fontSize: "16px",
                        color: colors.text,
                        wordBreak: "break-word",
                      }}
                    >
                      {!values.previousAssignedResponsibilityMember &&
                      !values.previousAssignedResponsibilityMemberRegNo ? (
                        "—"
                      ) : (
                        <>
                          {getStringFromJSX(
                            applyClassToCharacters(
                              values.previousAssignedResponsibilityMember,
                              "ur"
                            )
                          ) || "—"}{" "}
                          (
                          {values.previousAssignedResponsibilityMemberRegNo ||
                            "—"}
                          )
                        </>
                      )}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="1">
                <div className="d-flex align-items-center h-100">
                  <Button
                    style={{
                      backgroundColor: colors.primary,
                      borderColor: colors.primary,
                      color: "white",
                      borderRadius: "6px",
                      width: "100%",
                    }}
                    onClick={() => {
                      setShowSearch(!showSearch);
                      setRegNoError(false);
                      setRegNoForSearch("");
                    }}
                  >
                    <BiSearchAlt
                      size={15}
                      color="white"
                      style={{ marginRight: "5px" }}
                    />
                    {<GetLanguageString props="member_search_member" />}
                  </Button>
                </div>
              </Col>
              {showSearch && (
                <Col md="12" className="mt-3">
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      border: "none",
                      padding: "15px",
                    }}
                  >
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props="member_search_member" />
                    </CardTitle>

                    <Row className="mb-3">
                      <Col md="6">
                        <FormGroup check inline>
                          <Input
                            type="radio"
                            name="searchOption"
                            id="searchByName"
                            checked={searchOption === "name"}
                            onChange={() => setSearchOption("name")}
                          />
                          <Label check for="searchByName">
                            <GetLanguageString props="member_search_by_name" />
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Input
                            type="radio"
                            name="searchOption"
                            id="searchByRegNo"
                            checked={searchOption === "regNo"}
                            onChange={() => setSearchOption("regNo")}
                          />
                          <Label check for="searchByRegNo">
                            <GetLanguageString props="member_search_by_regno" />
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>

                    {searchOption === "name" ? (
                      <Row>
                        <Col md="12">
                          <Card
                            className="mb-3"
                            style={{
                              borderRadius: "10px",
                              boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                              border: "none",
                              padding: "15px",
                            }}
                          >
                            <SearchAutoComplete
                              members={members}
                              setMembers={setMembers}
                              setName={setName}
                              setSearchByName={setShowSearch}
                              name={name}
                              type={"rufqa"}
                              loading={loadingSearch}
                              placeholder={t("member_search_by_name")}
                              handleOnSelect={handleOnSelect}
                              calledFrom="responsibility"
                            />
                          </Card>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col md="12">
                          {" "}
                          <Card
                            className="mb-3"
                            style={{
                              borderRadius: "10px",
                              boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                              border: "none",
                              padding: "15px",
                            }}
                          >
                            <InputGroup>
                              {" "}
                              <InputGroupText
                                onClick={handleSearchByRegNo}
                                disabled={loadingSearchByRegNo}
                                style={{
                                  backgroundColor: colors.primaryDark,
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                {loadingSearchByRegNo ? (
                                  <Spinner size="sm" color="light" />
                                ) : (
                                  <BiSearchAlt size={18} />
                                )}
                              </InputGroupText>
                              <Input
                                type="text"
                                placeholder={t("member_search_by_regno")}
                                value={regNoForSearch}
                                autoFocus={searchOption !== "name"}
                                onChange={(e) =>
                                  setRegNoForSearch(e.target.value)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleSearchByRegNo();
                                  }
                                }}
                                style={{
                                  borderColor: colors.border,
                                  color: colors.text,
                                }}
                              />
                              <InputGroupText
                                onClick={() => setShowSearch(false)}
                                style={{
                                  backgroundColor: colors.error,
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                <RxCross2 size={18} />
                              </InputGroupText>
                            </InputGroup>
                            {regNoError && (
                              <Alert
                                color="danger"
                                style={{ marginTop: "20px" }}
                              >
                                {selectedLanguage === "ur"
                                  ? "اس رجسٹریشن نمبر کے ساتھ کوئی رفیق موجود نہیں ہے"
                                  : "No result found against this Reg no"}
                              </Alert>
                            )}
                          </Card>
                        </Col>
                      </Row>
                    )}
                  </Card>
                </Col>
              )}
            </Row>
          </div>
          <div className="position-relative mb-5" style={{ padding: "0 10%" }}>
            {/* Progress Line - now full width */}
            <div
              className="position-absolute"
              style={{
                height: "3px",
                backgroundColor: colors.progressLine,
                top: "32%",
                left: "0",
                right: "0",
                transform: "translateY(-50%)",
                zIndex: 1,
                borderRadius: "3px",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${(currentStep - 1) * 20 + 20}%`,
                  backgroundColor: colors.primary,
                  transition: "width 0.5s ease",
                  borderRadius: "3px",
                }}
              />
            </div>
            <Row className="position-relative" style={{ zIndex: 2 }}>
              {[1, 2, 3, 4].map((step) => (
                <Col key={step} className="text-center">
                  <div className="d-flex flex-column align-items-center">
                    <Button
                      onClick={() =>
                        currentStep >= step && setCurrentStep(step)
                      }
                      onMouseEnter={() => setHoverStep(step)}
                      onMouseLeave={() => setHoverStep(null)}
                      disabled={currentStep < step}
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "8px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        boxShadow:
                          currentStep >= step
                            ? `0 2px 8px ${colors.primary}40`
                            : "none",
                        background:
                          currentStep >= step
                            ? hoverStep === step
                              ? colors.primaryDark
                              : colors.primary
                            : "white",
                        border:
                          currentStep >= step
                            ? "none"
                            : `3px solid ${colors.progressLine}`,
                        color: currentStep >= step ? "white" : colors.textLight,
                        cursor: currentStep >= step ? "pointer" : "not-allowed",
                        transition: "all 0.3s ease",
                        position: "relative",
                        borderColor:
                          currentStep === step
                            ? colors.primary
                            : colors.progressLine,
                      }}
                    >
                      {step}
                      {/* Small indicator for current step */}
                      {currentStep === step && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "-10px",
                            width: "0",
                            height: "0",
                            borderLeft: "8px solid transparent",
                            borderRight: "8px solid transparent",
                            borderTop: `8px solid ${colors.primary}`,
                          }}
                        />
                      )}
                    </Button>
                    <div
                      className="text-center ur"
                      style={{
                        fontWeight: currentStep >= step ? "600" : "500",
                        color:
                          currentStep >= step
                            ? colors.primary
                            : colors.textLight,
                        fontSize: "20px",
                        transition: "color 0.3s ease",
                      }}
                    >
                      <span style={{ marginTop: 50 }}>
                        {getStepTitle(step)}
                      </span>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          <div
            className="ibox-content p-4 mb-4"
            style={{
              minHeight: "200px",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)",
              border: `1px solid ${colors.border}`,
              backgroundColor: "rgb(253, 253, 253)",
            }}
          >
            {renderStepContent()}
          </div>

          <div className="d-flex justify-content-between">
            <Button
              color="default"
              onClick={prevStep}
              disabled={currentStep === 1}
              className="px-4"
              style={{
                background: currentStep === 1 ? colors.background : "white",
                color: currentStep === 1 ? colors.textLight : colors.primary,
                border:
                  currentStep === 1
                    ? `1px solid ${colors.border}`
                    : `1px solid ${colors.primary}`,
                borderRadius: "8px",
                transition: "all 0.3s ease",
                fontWeight: "500",
                padding: "10px 24px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              }}
            >
              {selectedLanguage === "ur" ? (
                <IoArrowForwardSharp
                  color={currentStep === 1 ? colors.textLight : colors.primary}
                  size={15}
                  style={{ marginLeft: 5, marginBottom: 1 }}
                />
              ) : (
                <IoArrowBackSharp
                  color={currentStep === 1 ? colors.textLight : colors.primary}
                  size={15}
                  style={{ marginRight: 5, marginBottom: 1 }}
                />
              )}
              <GetLanguageString props={"Previous"} />
            </Button>

            {currentStep === 4 ? (
              <Button
                color={"default"}
                onClick={handleSubmit}
                disabled={buttonDisable}
                className="px-4"
                style={{
                  background: buttonDisable
                    ? colors.border
                    : `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  transition: "all 0.3s ease",
                  fontWeight: "500",
                  padding: "10px 24px",
                  boxShadow: buttonDisable
                    ? "none"
                    : `0 4px 15px ${colors.primary}30`,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MdDoneAll
                  color="white"
                  size={17}
                  style={{ marginRight: 5, marginBottom: 1 }}
                />
                <GetLanguageString props={"Submit"} />
              </Button>
            ) : (
              <Button
                color={"default"}
                onClick={nextStep}
                disabled={currentStep === 4}
                className="px-4"
                style={{
                  background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  transition: "all 0.3s ease",
                  fontWeight: "500",
                  padding: "10px 24px",
                  boxShadow: `0 4px 15px ${colors.primary}30`,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <GetLanguageString props={"Next"} />
                {selectedLanguage === "ur" ? (
                  <IoArrowBackSharp
                    color="white"
                    size={15}
                    style={{ marginRight: 5, marginBottom: 1 }}
                  />
                ) : (
                  <IoArrowForwardSharp
                    color="white"
                    size={15}
                    style={{ marginLeft: 5, marginBottom: 1 }}
                  />
                )}
              </Button>
            )}
          </div>
        </>
      ) : (
        LoadingSpinner()
      )}
    </div>
  );
};

export default withRouter(MuavaneenResponsibilityRequestForm);
